<template>
    <div class="main-container">
        <!-- Navbar section -->
        <Navbar/>

        <!-- hero section -->
        <Hero/>

        <VeritasBanner/>

        <SofieBanner/>

        <AtariBanner/>

        <ContentSection :fullWidth="true" class="space-top">
            <template #header>{{ $t("research.academic_invetigation") }}</template>
            <template #main>
                <div v-for="(pdf, index) in pdfs" :key="index" class="pdf-download"><a :href="pdf.pdf" target="_blank"><i class="fas fa-file-pdf"></i> <span>{{ pdf.title }}</span></a></div>
            </template>
        </ContentSection>

        <!-- footer section -->
        <FooterMain/>

    </div>
</template>

<script>
import Hero from '../comp_trustami/Research/Hero';
import SofieBanner from '../comp_trustami/Research/SofieBanner';
import VeritasBanner from '../comp_trustami/Research/VeritasBanner';
import AtariBanner from '../comp_trustami/Research/AtariBanner';
import ContentSection from '../comp_trustami/Research/ContentSection';
import FooterMain from '../comp_trustami/FooterMain';
import Navbar from "../comp_trustami/NavbarSub";

export default {
    name: 'app',
    components: {
        Navbar,
        Hero,
        SofieBanner,
        VeritasBanner,
        AtariBanner,
        ContentSection,
        FooterMain,
    },

    data() {
        return {
            pdfs: [
                {
                    title: this.$t("research.topic_1"),
                    pdf: require("../assets/pdf/Trustami_TWS_Bachelor_Master_Thesis__AI_Review_Reply_Assistant.pdf")
                },
                {
                    title: this.$t("research.topic_2"),
                    pdf: require("../assets/pdf/Trustami_TWS_Bachelor_Master_Thesis__Deep_Learning_in_Content_Curation.pdf")
                },
                {
                    title: this.$t("research.topic_3"),
                    pdf: require("../assets/pdf/Trustami_TWS_Bachelor_Master_Thesis__Gain_Insights_of_3D_Marketplace_Data.pdf")
                },
                {
                    title: this.$t("research.topic_4"),
                    pdf: require("../assets/pdf/Trustami_VERITAS_Bachelor_Master_Thesis__Advanced_Topic_Modeling.pdf")
                },
                {
                    title: this.$t("research.topic_5"),
                    pdf: require("../assets/pdf/Trustami_VERITAS_Bachelor_Master_Thesis__Author_Propagation_Analysis.pdf")
                },
                {
                    title: this.$t("research.topic_6"),
                    pdf: require("../assets/pdf/Trustami_VERITAS_Bachelor_Master_Thesis__Automated_Fact_Checking.pdf")
                },
                {
                    title: this.$t("research.topic_7"),
                    pdf: require("../assets/pdf/Trustami_VERITAS_Bachelor_Master_Thesis__BIAS_within_Datasets.pdf")
                },
                {
                    title: this.$t("research.topic_8"),
                    pdf: require("../assets/pdf/Trustami_VERITAS_Bachelor_Master_Thesis__Fake_News_Detection.pdf")
                },
                {
                    title: this.$t("research.topic_9"),
                    pdf: require("../assets/pdf/Trustami_VERITAS_Bachelor_Master_Thesis__Labeling_Approaches.pdf")
                },
                {
                    title: this.$t("research.topic_10"),
                    pdf: require("../assets/pdf/Trustami_VERITAS_Bachelor_Master_Thesis__Recurrent_Visual_Embedding_for_Image_Text_Matching.pdf")
                },
                {
                    title: this.$t("research.topic_11"),
                    pdf: require("../assets/pdf/Trustami_VERITAS_Bachelor_Master_Thesis__Temporal_Change_of_Topics.pdf")
                }
            ]
        };
    },

    metaInfo: {
        title: 'Research - Trustami.AI Web Services',
        meta: [
            {
                name: 'description',
                content: 'Cutting-edge Machine Learning Research Projects.'
            }
        ],
        htmlAttrs: {
            lang: 'en',
            amp: true
        }
    }
}
</script>
